import BaseServiceCrud from './BaseServiceCrud';
import moment from 'moment';
import Constants from '../utils/constants';

export default class ReportedDayService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'reported-day';
    }
    getCriteria(criteria) {
        return this.objToQueryString({
            name: criteria.name,
            project: criteria.project ? criteria.project.id : null,
            date_from: criteria.dateFrom ? moment(criteria.dateFrom).format(Constants.DATE_GET_REQUEST_FORMAT) : undefined,
            date_to: criteria.dateTo ? moment(criteria.dateTo).format(Constants.DATE_GET_REQUEST_FORMAT) : undefined,
            status: criteria.status?.enumValue,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
            userName: criteria.userName,
            reportType: criteria.reportedDayType,
            rejectReason: criteria.rejectReason ? criteria.rejectReason : null,
            selectAll: criteria.selectAll,
            ids: criteria.ids ? criteria.ids : null
        });
    }

    _requestBodyFromElement(element) {
        const body = {...element};
        if (body.date != null && body.date !== '') {
            body.date = moment(body.date).format(Constants.DATE_JSON_FORMAT);
        }
        return body;
    }

    update(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/${element.id}`, {
            method: 'PUT',
            body: JSON.stringify(this._requestBodyFromElement(element)),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    add(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/add`, {
            method: 'POST',
            body: JSON.stringify(this._requestBodyFromElement(element)),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    remove(element) {
        
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/${element.id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    
    approve(elementId) {
        return this.fetch(`${this.domain}/${this.path}/approve/${elementId}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    approveEvent(elementId) {
        return this.fetch(`${this.domain}/${this.path}/approve-event/${elementId}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }


    reject(elementId) {
        return this.fetch(`${this.domain}/${this.path}/reject/${elementId}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    rejectEvent(elementId) {
        return this.fetch(`${this.domain}/${this.path}/reject-event/${elementId}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }


    reopen(elementId) {
        return this.fetch(`${this.domain}/${this.path}/reopen/${elementId}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    reopenEvent(elementId) {
        return this.fetch(`${this.domain}/${this.path}/reopen-event/${elementId}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }


    groupApprove(criteria, ids, selectAll) {
        criteria.ids = ids;
        criteria.selectAll = selectAll;
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/approve/group${queryString}`, {
            method: 'POST',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    groupReject(criteria, ids, rejectReason, selectAll) {
        criteria.ids = ids;
        criteria.rejectReason = rejectReason;
        criteria.selectAll = selectAll;
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/reject/group${queryString}`, {
            method: 'POST',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    groupOpen(criteria, ids, selectAll) {
        criteria.ids = ids;
        criteria.selectAll = selectAll;
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/open/group${queryString}`, {
            method: 'POST',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
